import { PopularCompany } from '../types/CompanyTypes';

export const popularCompanies: PopularCompany[] = [
  {
    id: 'google',
    name: 'Google',
    industry: 'Technology',
    glassdoor_rating: 4.4,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Google-EI_IE9079.htm',
    levels_url: 'https://www.levels.fyi/companies/google/salaries',
    salary_range: { min: 130000, max: 450000, currency: 'USD' },
    headquarters: 'Mountain View, CA',
    employee_count: '180,000+',
    tags: ['FAANG', 'Remote-friendly', 'AI/ML'],
    domains: ['google.com'],
  },
  {
    id: 'meta',
    name: 'Meta',
    industry: 'Technology',
    glassdoor_rating: 4.1,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Meta-EI_IE40772.htm',
    levels_url: 'https://www.levels.fyi/companies/facebook/salaries',
    salary_range: { min: 140000, max: 500000, currency: 'USD' },
    headquarters: 'Menlo Park, CA',
    employee_count: '67,000+',
    tags: ['FAANG', 'Metaverse', 'AI/ML'],
    domains: ['meta.com', 'facebook.com', 'fb.com'],
  },
  {
    id: 'amazon',
    name: 'Amazon',
    industry: 'Technology',
    glassdoor_rating: 3.9,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Amazon-EI_IE6036.htm',
    levels_url: 'https://www.levels.fyi/companies/amazon/salaries',
    salary_range: { min: 120000, max: 400000, currency: 'USD' },
    headquarters: 'Seattle, WA',
    employee_count: '1,500,000+',
    tags: ['FAANG', 'Cloud', 'E-commerce'],
    domains: ['amazon.com', 'aws.com'],
  },
  {
    id: 'apple',
    name: 'Apple',
    industry: 'Technology',
    glassdoor_rating: 4.2,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Apple-EI_IE1138.htm',
    levels_url: 'https://www.levels.fyi/companies/apple/salaries',
    salary_range: { min: 130000, max: 420000, currency: 'USD' },
    headquarters: 'Cupertino, CA',
    employee_count: '164,000+',
    tags: ['FAANG', 'Hardware', 'Consumer'],
    domains: ['apple.com'],
  },
  {
    id: 'netflix',
    name: 'Netflix',
    industry: 'Technology',
    glassdoor_rating: 4.0,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Netflix-EI_IE11891.htm',
    levels_url: 'https://www.levels.fyi/companies/netflix/salaries',
    salary_range: { min: 200000, max: 600000, currency: 'USD' },
    headquarters: 'Los Gatos, CA',
    employee_count: '13,000+',
    tags: ['FAANG', 'Streaming', 'High-pay'],
    domains: ['netflix.com'],
  },
  {
    id: 'microsoft',
    name: 'Microsoft',
    industry: 'Technology',
    glassdoor_rating: 4.3,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Microsoft-EI_IE1651.htm',
    levels_url: 'https://www.levels.fyi/companies/microsoft/salaries',
    salary_range: { min: 120000, max: 400000, currency: 'USD' },
    headquarters: 'Redmond, WA',
    employee_count: '221,000+',
    tags: ['Big Tech', 'Cloud', 'AI/ML'],
    domains: ['microsoft.com'],
  },
  {
    id: 'salesforce',
    name: 'Salesforce',
    industry: 'Technology',
    glassdoor_rating: 4.1,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Salesforce-EI_IE11159.htm',
    levels_url: 'https://www.levels.fyi/companies/salesforce/salaries',
    salary_range: { min: 120000, max: 350000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '73,000+',
    tags: ['Big Tech', 'CRM', 'Cloud'],
    domains: ['salesforce.com'],
  },
  {
    id: 'oracle',
    name: 'Oracle',
    industry: 'Technology',
    glassdoor_rating: 3.8,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Oracle-EI_IE1737.htm',
    levels_url: 'https://www.levels.fyi/companies/oracle/salaries',
    salary_range: { min: 100000, max: 300000, currency: 'USD' },
    headquarters: 'Austin, TX',
    employee_count: '143,000+',
    tags: ['Big Tech', 'Database', 'Cloud'],
    domains: ['oracle.com'],
  },
  {
    id: 'ibm',
    name: 'IBM',
    industry: 'Technology',
    glassdoor_rating: 3.9,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-IBM-EI_IE354.htm',
    levels_url: 'https://www.levels.fyi/companies/ibm/salaries',
    salary_range: { min: 90000, max: 250000, currency: 'USD' },
    headquarters: 'Armonk, NY',
    employee_count: '280,000+',
    tags: ['Big Tech', 'Enterprise', 'AI/ML'],
    domains: ['ibm.com'],
  },
  {
    id: 'stripe',
    name: 'Stripe',
    industry: 'Fintech',
    glassdoor_rating: 4.3,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Stripe-EI_IE671932.htm',
    levels_url: 'https://www.levels.fyi/companies/stripe/salaries',
    salary_range: { min: 150000, max: 450000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '8,000+',
    tags: ['Fintech', 'Payments', 'Remote-friendly'],
    domains: ['stripe.com'],
  },
  {
    id: 'notion',
    name: 'Notion',
    industry: 'Technology',
    glassdoor_rating: 4.2,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Notion-EI_IE2383785.htm',
    levels_url: 'https://www.levels.fyi/companies/notion/salaries',
    salary_range: { min: 140000, max: 380000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '500+',
    tags: ['Productivity', 'Scale-up', 'Remote-friendly'],
    domains: ['makenotion.com', 'notion.so'],
  },
  {
    id: 'figma',
    name: 'Figma',
    industry: 'Technology',
    glassdoor_rating: 4.5,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Figma-EI_IE1537457.htm',
    levels_url: 'https://www.levels.fyi/companies/figma/salaries',
    salary_range: { min: 140000, max: 400000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '1,500+',
    tags: ['Design', 'Scale-up', 'Collaborative'],
    domains: ['figma.com'],
  },
  {
    id: 'datadog',
    name: 'Datadog',
    industry: 'Technology',
    glassdoor_rating: 4.2,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Datadog-EI_IE1064541.htm',
    levels_url: 'https://www.levels.fyi/companies/datadog/salaries',
    salary_range: { min: 130000, max: 350000, currency: 'USD' },
    headquarters: 'New York, NY',
    employee_count: '6,000+',
    tags: ['Monitoring', 'Cloud', 'DevOps'],
    domains: ['datadoghq.com'],
  },
  {
    id: 'spotify',
    name: 'Spotify',
    industry: 'Technology',
    glassdoor_rating: 4.1,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Spotify-EI_IE408251.htm',
    levels_url: 'https://www.levels.fyi/companies/spotify/salaries',
    salary_range: { min: 130000, max: 380000, currency: 'USD' },
    headquarters: 'Stockholm, Sweden',
    employee_count: '9,000+',
    tags: ['Music', 'Remote-friendly', 'Scale-up'],
    domains: ['spotify.com'],
  },
  {
    id: 'airbnb',
    name: 'Airbnb',
    industry: 'Technology',
    glassdoor_rating: 4.1,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Airbnb-EI_IE391850.htm',
    levels_url: 'https://www.levels.fyi/companies/airbnb/salaries',
    salary_range: { min: 140000, max: 420000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '6,900+',
    tags: ['Travel', 'Remote-friendly', 'Scale-up'],
    domains: ['airbnb.com'],
  },
  {
    id: 'uber',
    name: 'Uber',
    industry: 'Technology',
    glassdoor_rating: 3.9,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Uber-EI_IE575263.htm',
    levels_url: 'https://www.levels.fyi/companies/uber/salaries',
    salary_range: { min: 130000, max: 400000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '32,000+',
    tags: ['Mobility', 'Scale-up', 'Delivery'],
    domains: ['uber.com'],
  },
  {
    id: 'openai',
    name: 'OpenAI',
    industry: 'Technology',
    glassdoor_rating: 4.3,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-OpenAI-EI_IE2556798.htm',
    levels_url: 'https://www.levels.fyi/companies/openai/salaries',
    salary_range: { min: 200000, max: 600000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '2,000+',
    tags: ['AI/ML', 'Research', 'High-pay'],
    domains: ['openai.com'],
  },
  {
    id: 'revolut',
    name: 'Revolut',
    industry: 'Fintech',
    glassdoor_rating: 3.6,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Revolut-EI_IE1446498.htm',
    levels_url: 'https://www.levels.fyi/companies/revolut/salaries',
    salary_range: { min: 80000, max: 250000, currency: 'GBP' },
    headquarters: 'London, UK',
    employee_count: '8,000+',
    tags: ['Fintech', 'Banking', 'Global'],
    domains: ['revolut.com'],
  },
  {
    id: 'coinbase',
    name: 'Coinbase',
    industry: 'Fintech',
    glassdoor_rating: 3.7,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Coinbase-EI_IE721672.htm',
    levels_url: 'https://www.levels.fyi/companies/coinbase/salaries',
    salary_range: { min: 150000, max: 450000, currency: 'USD' },
    headquarters: 'Remote (San Francisco, CA)',
    employee_count: '3,500+',
    tags: ['Fintech', 'Crypto', 'Remote-first'],
    domains: ['coinbase.com'],
  },
  {
    id: 'plaid',
    name: 'Plaid',
    industry: 'Fintech',
    glassdoor_rating: 4.0,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Plaid-EI_IE1234567.htm',
    levels_url: 'https://www.levels.fyi/companies/plaid/salaries',
    salary_range: { min: 140000, max: 380000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '1,000+',
    tags: ['Fintech', 'APIs', 'Banking'],
    domains: ['plaid.com'],
  },
  {
    id: 'robinhood',
    name: 'Robinhood',
    industry: 'Fintech',
    glassdoor_rating: 3.5,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Robinhood-EI_IE1081850.htm',
    levels_url: 'https://www.levels.fyi/companies/robinhood/salaries',
    salary_range: { min: 140000, max: 400000, currency: 'USD' },
    headquarters: 'Menlo Park, CA',
    employee_count: '2,300+',
    tags: ['Fintech', 'Trading', 'Consumer'],
    domains: ['robinhood.com'],
  },
  {
    id: 'crowdstrike',
    name: 'CrowdStrike',
    industry: 'Security',
    glassdoor_rating: 4.0,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-CrowdStrike-EI_IE795976.htm',
    levels_url: 'https://www.levels.fyi/companies/crowdstrike/salaries',
    salary_range: { min: 120000, max: 320000, currency: 'USD' },
    headquarters: 'Austin, TX',
    employee_count: '8,500+',
    tags: ['Security', 'Endpoint', 'Cloud'],
    domains: ['crowdstrike.com'],
  },
  {
    id: 'sentinelone',
    name: 'SentinelOne',
    industry: 'Security',
    glassdoor_rating: 3.9,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-SentinelOne-EI_IE1277174.htm',
    levels_url: 'https://www.levels.fyi/companies/sentinelone/salaries',
    salary_range: { min: 120000, max: 300000, currency: 'USD' },
    headquarters: 'Mountain View, CA',
    employee_count: '2,500+',
    tags: ['Security', 'AI-powered', 'Endpoint'],
    domains: ['sentinelone.com'],
  },
  {
    id: 'paloalto',
    name: 'Palo Alto Networks',
    industry: 'Security',
    glassdoor_rating: 4.0,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Palo-Alto-Networks-EI_IE115142.htm',
    levels_url: 'https://www.levels.fyi/companies/palo-alto-networks/salaries',
    salary_range: { min: 130000, max: 350000, currency: 'USD' },
    headquarters: 'Santa Clara, CA',
    employee_count: '15,000+',
    tags: ['Security', 'Network', 'Cloud'],
    domains: ['paloaltonetworks.com'],
  },
  {
    id: 'cloudflare',
    name: 'Cloudflare',
    industry: 'Technology',
    glassdoor_rating: 4.1,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Cloudflare-EI_IE900722.htm',
    levels_url: 'https://www.levels.fyi/companies/cloudflare/salaries',
    salary_range: { min: 130000, max: 350000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '4,000+',
    tags: ['Cloud', 'Infrastructure', 'Security'],
    domains: ['cloudflare.com'],
  },
  {
    id: 'vercel',
    name: 'Vercel',
    industry: 'Technology',
    glassdoor_rating: 4.2,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Vercel-EI_IE3827498.htm',
    levels_url: 'https://www.levels.fyi/companies/vercel/salaries',
    salary_range: { min: 140000, max: 350000, currency: 'USD' },
    headquarters: 'San Francisco, CA',
    employee_count: '500+',
    tags: ['Developer Tools', 'Remote-first', 'Next.js'],
    domains: ['vercel.com'],
  },
  {
    id: 'shopify',
    name: 'Shopify',
    industry: 'Technology',
    glassdoor_rating: 3.9,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Shopify-EI_IE675933.htm',
    levels_url: 'https://www.levels.fyi/companies/shopify/salaries',
    salary_range: { min: 110000, max: 330000, currency: 'CAD' },
    headquarters: 'Ottawa, Canada',
    employee_count: '10,000+',
    tags: ['E-commerce', 'Remote-first', 'Developer Tools'],
    domains: ['shopify.com'],
  },
  {
    id: 'canva',
    name: 'Canva',
    industry: 'Technology',
    glassdoor_rating: 4.4,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Canva-EI_IE1098521.htm',
    levels_url: 'https://www.levels.fyi/companies/canva/salaries',
    salary_range: { min: 120000, max: 350000, currency: 'USD' },
    headquarters: 'Sydney, Australia',
    employee_count: '4,000+',
    tags: ['Design', 'Remote-friendly', 'Scale-up'],
    domains: ['canva.com'],
  },
  {
    id: 'palantir',
    name: 'Palantir',
    industry: 'Technology',
    glassdoor_rating: 3.8,
    glassdoor_url: 'https://www.glassdoor.com/Overview/Working-at-Palantir-Technologies-EI_IE236375.htm',
    levels_url: 'https://www.levels.fyi/companies/palantir/salaries',
    salary_range: { min: 130000, max: 380000, currency: 'USD' },
    headquarters: 'Denver, CO',
    employee_count: '3,800+',
    tags: ['Data', 'Government', 'Enterprise'],
    domains: ['palantir.com'],
  },
];
